module.exports = __webpack_public_path__ + "img/ill_badge_failed.d912e08d.svg";